import { render, staticRenderFns } from "./StudentRegister.vue?vue&type=template&id=1c5c9e18&scoped=true&"
import script from "./StudentRegister.vue?vue&type=script&lang=js&"
export * from "./StudentRegister.vue?vue&type=script&lang=js&"
import style0 from "./StudentRegister.vue?vue&type=style&index=0&id=1c5c9e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c9e18",
  null
  
)

export default component.exports